import React from "react";

const CardDetail = ({ cardsDetails, isDisabled = false }) => {
  const handleOnChange = (e, funcSet) => {
    e.preventDefault();
    funcSet(e.target.value);
  };

  const handleOnClickToogle = (e, funcSet, value) => {
    e.preventDefault();
    funcSet(!value);
  };

  return (
    <div className="flex flex-col px-5 py-5 gap-5 w-full overflow-y-auto">
      <div className="flex flex-col gap-4">
        <div className="flex flex-col">
          <div className="font-bold">Card Detail</div>
          <div className="text-[14px] text-gray-400">
            These fields do not appear in card
          </div>
        </div>

        {cardsDetails.slice(0, 2).map((val, ind) => (
          <div
            key={ind}
            id={val.label.replace(" ", "").replace("*", "")}
            className="flex flex-row w-full items-center"
          >
            <div className="flex flex-row w-4/12 justify-start items-center gap-3">
              <div>{val.label.slice(0, val.label.length - 1)}</div>
              {val.label.includes("*") ? (
                <div
                  className="tooltip bg-gray-200 rounded-full h-[20px] w-[20px] text-[9px] flex justify-center items-center hover:bg-gray-300"
                  data-tip={"This field is required."}
                >
                  i
                </div>
              ) : null}
            </div>
            <input
              className={`flex flex-col border border-black rounded-lg w-3/4 md:w-1/2 h-[40px] px-3 ${
                isDisabled ? "bg-gray-200" : ""
              }`}
              onChange={(e) => handleOnChange(e, val.funcSet)}
              value={val.value}
              disabled={isDisabled}
            />
          </div>
        ))}
        <div className="flex flex-row w-full items-center">
          <div className="flex flex-col w-4/12">{cardsDetails[2].label}</div>
          <textarea
            className="flex flex-col border border-black rounded-lg w-3/4 md:w-1/2 px-3 py-3"
            onChange={(e) => handleOnChange(e, cardsDetails[2].funcSet)}
            value={cardsDetails[2].value}
            rows={5}
          />
        </div>
        <div className="flex flex-row w-full items-center">
          <div className="flex flex-col w-4/12">{cardsDetails[3].label}</div>
          <label
            className="inline-flex items-center cursor-pointer w-6/12"
            onClick={(e) =>
              handleOnClickToogle(
                e,
                cardsDetails[3].funcSet,
                cardsDetails[3].value,
              )
            }
          >
            <input
              type="checkbox"
              value={cardsDetails[3].value}
              className="sr-only peer"
              checked={cardsDetails[3].value}
            />
            <div
              className={`relative w-16 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600 dark:peer-checked:bg-blue-600 text-white`}
            ></div>
          </label>
        </div>
      </div>
    </div>
  );
};

export default CardDetail;
